interface AuditEntry {
  id: string
  timestamp: string
  action: string
  entity: string
  user: string
}
const auditLog: AuditEntry[] = []
export function logAuditEvent(
  action: string,
  entity: string,
  user: string,
): void {
  const entry: AuditEntry = {
    id: `audit-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    timestamp: new Date().toISOString(),
    action,
    entity,
    user,
  }
  auditLog.unshift(entry)
  // Keep only last 50 entries
  if (auditLog.length > 50) {
    auditLog.pop()
  }
  console.log(`[Audit] ${action} - ${entity} by ${user}`)
}
export function getRecentAuditEntries(limit: number = 10): AuditEntry[] {
  return auditLog.slice(0, limit)
}
export function clearAuditLog(): void {
  auditLog.length = 0
}
